export default __webpack_public_path__ + "static/media/499.2e83850d.gif";